var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.75C9.15 0.75 0.75 9.15 0.75 19.5C0.75 29.85 9.15 38.25 19.5 38.25C29.85 38.25 38.25 29.85 38.25 19.5C38.25 9.15 29.85 0.75 19.5 0.75ZM19.5 28.875C18.4688 28.875 17.625 28.0312 17.625 27V19.5C17.625 18.4688 18.4688 17.625 19.5 17.625C20.5312 17.625 21.375 18.4688 21.375 19.5V27C21.375 28.0312 20.5312 28.875 19.5 28.875ZM21.375 13.875H17.625V10.125H21.375V13.875Z",
    fill: "#287AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector (4).acac31440c5ee4c48443a75f90299939.svg";
export { ForwardRef as ReactComponent };